import React, { useEffect, useState } from "react";

// import ArrowRightIcon from "/public/images/summer-promo-smartico/arrow-left.svg";
import { getCookie } from "../../../../../../helpers/cookies";
import { useIsMobile } from "../../../device/selectors";
import { useSmarticoRaffleDrawById } from "../../store";
import { SmarticoRaffleDrawIds } from "../../interfaces/SmarticoRaffleDrawIds";
import { useTimer } from "../../../../../hooks/useTimer";
import { cn } from "../../../../../../lib/utils";
import { useRaffleContext } from "../../../../../(custom-header)/spring-daily-raffle/context";
import { TabKey } from "./AllPrizesModal/utils/types";
import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";

function TombolaStickyRender() {
  const { viewAllPrizes } = useRaffleContext();
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const [isBannerInView, setIsBannerInView] = useState(true);
  const isMobile = useIsMobile();
  const dailyDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.HOURLY_DRAW);
  const grandDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.GRAND_DRAW);
  const draw = dailyDraw.execution_ts >= Date.now() ? dailyDraw : grandDraw;
  const timer = useTimer(String(draw.id), draw.execution_ts, undefined, "millisecond");
  const daysCount = timer.days?.replace(/^0+/, "") || "0";
  const daysLabel = `${daysCount} ${Number(daysCount) === 1 ? "Day" : "Days"}`;

  useEffect(() => {
    const onRaffleToggleStickyHeader = (event: CustomEventInit<boolean>) => {
      setIsBannerInView(event.detail);
    };
    window.addEventListener("RAFFLE_TOGGLE_STICKY_HEADER", onRaffleToggleStickyHeader);

    return () => {
      window.removeEventListener("RAFFLE_TOGGLE_STICKY_HEADER", onRaffleToggleStickyHeader);
    };
  }, []);
  if (draw.execution_ts === 0) {
    return null;
  }

  return (
    <>
      <div
        className={cn(
          "min-h-[68px] lg:min-h-[64px] flex font-jost max-lg:flex-col lg:flex-row-reverse lg:justify-center items-center w-full fixed-theme bg-[#F5F5F5] shadow-[0_-1.5px_8px_0_rgba(0,0,0,0.20)] pt-2 pb-6 px-3 z-[1004] lg:px-4 lg:py-3 gap-2 lg:gap-[166px] transition-all duration-500 ease-in-out bottom-0",
          isBannerInView ? "opacity-0 translate-y-full" : "opacity-100 translate-y-0"
        )}>
        <div className={"flex justify-between items-center mx-auto w-full lg:max-w-[1312px]"}>
          <div className={"max-lg:hidden"} />

          <div className={"flex flex-col lg:items-center gap-1 lg:flex-row"}>
            <div className={"uppercase text-gray-5 text-[10px] leading-3 font-medium lg:text-base lg:leading-[22px]"}>
              Next draw in:
            </div>
            <div className={"text-sm font-medium text-dark-1 lg:text-base"}>
              <div className={"flex items-center gap-1"}>
                {timer.isPastADay ? (
                  <div>{daysLabel}</div>
                ) : (
                  <>
                    <div>{timer.hours}h</div>
                    <span>:</span>
                    <div>{timer.minutes}m</div>
                    <span>:</span>
                    <div className={"relative"}>
                      <span className={"inline-block min-w-4.5 lg:min-w-5"}>{timer.seconds}</span>
                      <span className={"text-[10px] leading-none inline-block min-w-[13px] lg:min-w-4"}>
                        {/*00*/}
                        {Math.floor(timer.milliseconds / 10)
                          .toString()
                          .padStart(2, "0")}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div>
            <button
              onClick={() => {
                viewAllPrizes(TabKey.PREMII_ZILNIC);
              }}
              className={"theme-btn theme-btn-primary theme-btn-sm lg:theme-btn-md uppercase min-w-[188px]"}>
              Get draw tickets
              <ChevronsRightIcon variant={2} className={"size-4 lg:size-6 shrink-0"} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TombolaStickyRender;
